import { isString as lo_isString } from 'es-toolkit';

// Deterministic (SSR-safe) check for a raw CSS size value. Covers sizing/global
// keywords, <length>/<percentage> units, and calc(); avoids CSS.supports()
// which is browser-only and would cause hydration mismatches.
const rxCssSizeTest: RegExp = /^(auto|inherit|initial|unset|revert|fit-content|min-content|max-content|calc\(.+\)|\d+(\.\d+)?(px|em|rem|%|vh|vw|vmin|vmax|svh|lvh|dvh|svw|lvw|dvw|ch|cm|mm|in|pt|pc))$/;

export function isCssSize(value: unknown): boolean {
    if (!lo_isString(value)) {
        return false;
    }

    return rxCssSizeTest.test(value);
}
